import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { Animations } from '../../animations';

@Component({
    selector: 'loading',
    templateUrl: 'loading.html',
    styleUrls: ['./loading.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.fadeInOut(500)],
    changeDetection: ChangeDetectionStrategy.Default
})
export class LoadingComponent {
    @Input() delayTime: number = 0;
    @Input() fadeInTime: number = 250;
    @Input() fadeOutTime: number = 500;
    @Input() loadingText: string = '';
    @Input() loading: boolean = true;
}
